export type CreditProgressBarLabelStatus = "available" | "unavailable" | "earned";

export function getCreditProgressBarLabel(
  creditType: "lateness" | "cancellation",
  status: CreditProgressBarLabelStatus
): string {
  const prefix = creditType === "cancellation" ? "Same-day cancellation" : "Lateness";
  return `${prefix} credit ${status}`;
}
